import type { Novidade } from './tipos';

/**
 * Fase 2, W23 (K11): "Criar tarefa" no histórico de qualquer registro, com o card ligado a ele e o link de volta. A imagem vem
 * da prova `scripts/provas/w23-parceiro-tarefa.ts` (`CAPTURAR=1`, modo discreto ligado).
 */
export const novidadeTarefaRegistro: Novidade = {
  id: '2026-10-05-tarefa-registro',
  publicada_em: '2026-10-05',
  tipo: 'melhoria',
  modulo: 'tarefas',
  permissao: 'tarefas.criar',
  rota: '/operacao/tarefas/kanban',
  textos: {
    pt: {
      titulo: 'Criar tarefa a partir de qualquer registro',
      resumo: 'No histórico de um cliente, fatura, pedido ou funcionário, Criar tarefa abre o card do Tarefas já ligado ao registro.',
      passos: [
        'Na ficha do registro, clique em Criar tarefa, ao lado de Seguir, no histórico.',
        'O formulário mostra a que registro o card fica ligado; preencha o título e salve.',
        'Na ficha do card, a linha Vínculo leva de volta ao registro.',
        'Quem não pode ver o registro vê só o tipo dele no card. A aprovação continua só pela pessoa que aprova.',
      ],
    },
    en: {
      titulo: 'Create a task from any record',
      resumo: 'In the history of a customer, invoice, order or employee, Create task opens the Tasks card already linked to the record.',
      passos: [
        'On the record, click Create task, next to Follow, in the history.',
        'The form shows which record the card is linked to; fill in the title and save.',
        'On the card, the Link line leads back to the record.',
        'Whoever cannot see the record sees only its type on the card. Approval is still done only by the approver.',
      ],
    },
    es: {
      titulo: 'Crear una tarea a partir de cualquier registro',
      resumo: 'En el historial de un cliente, factura, pedido o empleado, Crear tarea abre la tarjeta de Tareas ya vinculada al registro.',
      passos: [
        'En la ficha del registro, haz clic en Crear tarea, al lado de Seguir, en el historial.',
        'El formulario muestra a qué registro queda vinculada la tarjeta; completa el título y guarda.',
        'En la ficha de la tarjeta, la línea Vínculo lleva de vuelta al registro.',
        'Quien no puede ver el registro ve solo su tipo en la tarjeta. La aprobación sigue siendo solo de quien aprueba.',
      ],
    },
  },
  imagens: ['/novidades/2026-10-05-tarefa-registro/criar.webp', null, null, null],
  treinamento: { curso: 'novidades' },
};
